<template>
    <div class="flex items-center">
        <base-button-icon
            @click="openShareModal"
            icon-name="share"
            :button-text="$t('SHARE')"
            :hide-text="isWordyLocale"
        />

        <share-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            :show-special="showSpecial"
            :modal-image="modalImage"
        />
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButtonIcon from './BaseButtonIcon.vue';
    import ShareModal from './ShareModal.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonIcon,
            ShareModal,
        },

        data() {
            return {
                showModal: false,
                showSpecial: false,
                modalImage: '',
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            isWordyLocale() {
                return this.customizerStore.isWordyLocale;
            },
        },

        methods: {
            openShareModal(e) {
                this.takeSnapshot();

                this.showSpecial = false;

                if (e.altKey && e.shiftKey) {
                    this.showSpecial = true;
                }

                this.showModal = true;
            },

            takeSnapshot() {
                this.emitter.$emit('snapshot', {
                    controllerId: this.viewController.id,
                    view: 'Side',
                    overrideWidth: 900,
                    overrideHeight: 900,
                    done: (data) => {
                        this.modalImage = data;
                    },
                });
            },
        },
    };
</script>
